import React from "react";
import { NakiNigunHomeFeaturedTemplate } from "themes/application/naki-nigun/components";

function NakiNigunHomeFeatured(props) {
    return <NakiNigunHomeFeaturedTemplate {...props} />;
}

export default NakiNigunHomeFeatured;
